/* arduview storefront — scroll reveal + Klaviyo list subscribe + checkout passthrough */
(function(){
  "use strict";
  var KLAVIYO_COMPANY = "SvpLu3";
  var KLAVIYO_LIST = "XdSSdg";
  var AFTER_SIGNUP = "/pages/arduview-deposit";

  var reveals = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target);}});},{threshold:0.15,rootMargin:"0px 0px -8% 0px"});
    reveals.forEach(function(el){io.observe(el);});
  } else { reveals.forEach(function(el){el.classList.add("in");}); }

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  document.querySelectorAll(".cta__form").forEach(function(form){
    form.addEventListener("submit", function(ev){
      ev.preventDefault();
      var input = form.querySelector(".cta__input");
      var email = (input && input.value || "").trim();
      if (!EMAIL_RE.test(email)) { if(input){input.focus();} return; }
      var btn = form.querySelector("button,[type=submit]"); if(btn){btn.disabled=true;}
      fetch("https://a.klaviyo.com/client/subscriptions/?company_id=" + KLAVIYO_COMPANY, {
        method:"POST",
        headers:{"content-type":"application/json","revision":"2024-10-15"},
        body: JSON.stringify({data:{type:"subscription",attributes:{profile:{data:{type:"profile",attributes:{email:email}}}},relationships:{list:{data:{type:"list",id:KLAVIYO_LIST}}}}})
      }).then(function(){ if(AFTER_SIGNUP){ window.location.href = AFTER_SIGNUP; } else { form.innerHTML = "<p>you're on the list.</p>"; } })
        .catch(function(){ if(btn){btn.disabled=false;} alert("Something went wrong — try again."); });
    });
  });
})();